export default function ServicesSection() {
  const services = [
    {
      number: '01',
      title: '부동산 분양대행',
      description: '전문적인 분양 마케팅과 고객 관리를 통해 성공적인 분양을 실현합니다.',
      icon: 'ri-building-line',
    },
    {
      number: '02',
      title: '부동산 투자자문',
      description: '시장 분석과 투자 전략 수립으로 최적의 투자 기회를 제공합니다.',
      icon: 'ri-line-chart-line',
    },
    {
      number: '03',
      title: '부동산 개발사업',
      description: '기획부터 완공까지 체계적인 프로젝트 관리로 가치를 창출합니다.',
      icon: 'ri-hammer-line',
    },
    {
      number: '04',
      title: '부동산 자산관리',
      description: '효율적인 자산 운영과 관리로 안정적인 수익을 보장합니다.',
      icon: 'ri-shield-check-line',
    },
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16" data-aos="fade-up">
          <p className="text-primary text-sm font-semibold tracking-wider uppercase mb-3">
            Business Field
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-secondary mb-4 font-display">
            사업분야
          </h2>
          <p className="text-gray-600 text-base max-w-2xl mx-auto">
            다양한 부동산 서비스를 통해 고객의 성공을 함께 만들어갑니다
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              data-aos="fade-up"
              data-aos-delay={index * 100}
              className="group relative bg-white rounded-lg overflow-hidden shadow-md hover:shadow-2xl transition-all duration-500 cursor-pointer"
            >
              <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-accent/10 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
              
              <div className="relative p-8 h-80 flex flex-col">
                <div className="w-16 h-16 flex items-center justify-center bg-primary/10 rounded-lg mb-6 group-hover:bg-primary group-hover:scale-110 transition-all duration-300">
                  <i className={`${service.icon} text-3xl text-primary group-hover:text-white transition-colors duration-300`}></i>
                </div>
                
                <h3 className="text-xl font-bold text-secondary mb-3 group-hover:text-primary transition-colors duration-300">
                  {service.title}
                </h3>
                
                <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-grow">
                  {service.description}
                </p>
                
                <div className="flex items-center justify-between mt-auto">
                  <span className="text-5xl font-bold text-primary/20 group-hover:text-primary/40 transition-colors duration-300">
                    {service.number}
                  </span>
                  <i className="ri-arrow-right-line text-2xl text-primary opacity-0 group-hover:opacity-100 transform translate-x-0 group-hover:translate-x-2 transition-all duration-300"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
